// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.m-nav__item .m-dropdown__wrapper .m-dropdown__inner {\n  max-height: 400px;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
